import { getAncestorsForConstructor } from './target_properties';
export function bindInstanceMethods(constructor, module) {
  const instanceMethodNames = getMethodNamesForConstructor(constructor);
  instanceMethodNames.forEach(name => {
    module[name] = module[name].bind(module);
  });
}

function getMethodNamesForConstructor(constructor) {
  const ancestors = getAncestorsForConstructor(constructor);
  return Array.from(ancestors.reduce((targetNames, constructor) => {
    getOwnTargetNamesForConstructor(constructor).forEach(name => targetNames.add(name));
    return targetNames;
  }, new Set()));
}

function getOwnTargetNamesForConstructor(constructor) {
  const definition = constructor['methods'];
  return Array.isArray(definition) ? definition : [];
}